import { ProductType } from '@common/enums';
import { convertProductsToProductDetailsList } from '@common/utils';

export const convertDiagonalCornersToProductDetails = convertProductsToProductDetailsList(ProductType.DIAGONAL);
